import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Marca una petición que NO debe heredar el act-as activo (ni la justificación
 * cross-tenant one-shot) aunque su ruta sí sea tenant-scoped.
 *
 * Existe por llamadas auxiliares de catálogo disparadas desde módulos que NO
 * son tenant-scoped. Ejemplo real: la vista de evidencia de documentos legales
 * (M20, que opera sin act-as por diseño — ver `TENANT_AGNOSTIC_PATHS`) resuelve
 * nombres de tenant contra `/v1/tenants` solo para mostrar un label. Esa misma
 * ruta SÍ debe llevar act-as cuando el back-office la usa para gestionar un
 * tenant concreto; lo que no puede pasar es que un SUPER_ADMIN que dejó act-as
 * activo en otra pantalla (persiste en sessionStorage hasta `clearActAs()`)
 * entre a documentos legales y esa llamada de catálogo arrastre
 * `X-Act-As-Tenant-Id` + `X-Cross-Tenant-Justification` sin que la justificación
 * tenga nada que ver con lo que se está consultando — el backend audita esa
 * cabecera igual, y quedaría un registro erróneo.
 *
 * El opt-in va por petición, igual que `SKIP_ERROR_TOAST`: la ruta en sí sigue
 * necesitando act-as para el resto de sus consumidores.
 */
export const SKIP_ACT_AS = new HttpContextToken<boolean>(() => false);

export function skipActAs(): HttpContext {
  return new HttpContext().set(SKIP_ACT_AS, true);
}
